import React from 'react';
import styled from 'styled-components';
import { V2ThemeProvider } from '../theme/V2ThemeProvider';
import { V2FiltersProvider } from '../context/V2FiltersContext';
import { V2GlobalView } from './GlobalView';
import fonts from '../../theme/fonts';

/**
 * Hosts the v2 Global View inside the v1 layout. The v2 design tokens are kept
 * but the typefaces are remapped to the v1 ones (Oswald titles, SF Compact
 * text) so the page blends into the legacy application.
 */
const V1Typography = styled.div`
  flex: 1;
  min-width: 0;
  padding: 20px;

  @media (max-width: ${(props) =>
      props.theme.devices?.isTablet ? '0px' : '845px'}) {
    padding: 16px;
  }

  .v2-root {
    --font-serif: '${fonts.oswald}', sans-serif;
    --font-heading: '${fonts.oswald}', sans-serif;
    --font-heading-semibold: '${fonts.oswald_semibold}', '${fonts.oswald}',
      sans-serif;
    --font-sans: '${fonts.sfcompact_text}', sans-serif;
    --font-sans-bold: '${fonts.sfcompact_bold}', '${fonts.sfcompact_text}',
      sans-serif;
    --font-sans-semibold: '${fonts.sfcompact_semibold}',
      '${fonts.sfcompact_text}', sans-serif;
    --font-mono: '${fonts.sfcompact_text}', sans-serif;
    background: transparent;
  }
`;

export const DistributionAnalysis: React.FC = () => (
  <V1Typography>
    <V2ThemeProvider>
      <V2FiltersProvider>
        <V2GlobalView />
      </V2FiltersProvider>
    </V2ThemeProvider>
  </V1Typography>
);
